import Vue from 'vue'
import Router from 'vue-router'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { homeRoute, routes } from '../router/routes'

Vue.use(Router)

let router = new Router({
  routes
})

function showAccessNotice({ title, text }) {
  let secondsLeft = 5
  let countdownInterval
  Swal.fire({
    icon: "warning",
    title,
    text,
    confirmButtonText: `Dismiss (${secondsLeft}s)`,
    timer: 5000,
    timerProgressBar: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    onOpen: () => {
      countdownInterval = setInterval(() => {
        secondsLeft -= 1
        const btn = Swal.getConfirmButton()
        if (btn && secondsLeft > 0) {
          btn.textContent = `Dismiss (${secondsLeft}s)`
        }
      }, 1000)
    },
    onClose: () => {
      clearInterval(countdownInterval)
    },
  })
}

router.beforeEach((to, from, next) => {
  const navbar = $(".navbar-collapse")

  if (navbar) {
    navbar.collapse("hide")
  }

  if (to.matched.length === 0) {
    if (localStorage.getItem('token') == null) {
      next({ path: '/auth' })
    } else {
      showAccessNotice({
        title: "Invalid page",
        text: "The page you're trying to access doesn't exist.",
      })
      if (from.matched.length === 0) {
        next({ name: homeRoute })
      } else {
        next(false)
      }
    }
    return
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/auth',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))

      if (to.matched.some(record => record.meta.isAdmin)) {
        if (user.role && user.role.name === "Super Admin") {
          next()
        } else {
          showAccessNotice({
            title: "Access denied",
            text: "You don't have permission to view this page.",
          })
          if (from.matched.length === 0) {
            next({ name: homeRoute })
          } else {
            next(false)
          }
        }
      } else {
        if (to.matched.some(record => record.meta.roleRestricted)) {
          if (to.meta.roleRestricted.includes(user.role.name)) {
            showAccessNotice({
              title: "Access denied",
              text: "You don't have permission to view this page.",
            })
            if (from.matched.length === 0) {
              next({ name: homeRoute })
            } else {
              next(false)
            }
          } else {
            next()
          }
        } else {
          next()
        }
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: homeRoute
      })
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  $('.tooltip').remove();
  $('[data-toggle="tooltip"]').tooltip('dispose');
})

export default router